var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.675,
    height: 104.711,
    viewBox: "0 0 109.675 104.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 109.675,
    height: 104.711,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_14",
    "data-name": "Scroll Group 14",
    transform: "translate(-6)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(-214.758 -219.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M191.7,229.065c.868,20.921,28.24,29.323,52.261,25.477,13.5-2.154,25.95-8.177,32.04-18.022a25.831,25.831,0,0,0,3.812-11.391C283.415,186.119,188.952,162.525,191.7,229.065Z",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 170.984, -37.36)",
    fill: "#113f67",
    opacity: 0.287
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M.047,30.322C.737,6.277,22.49-3.38,41.582,1.04c10.729,2.476,20.624,9.4,25.464,20.714a39.3,39.3,0,0,1,3.029,13.092C72.934,79.682-2.14,106.8.047,30.322Z",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 336.433, 305.816)",
    fill: "#fff",
    opacity: 0.287
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(276.567 288)",
    fill: "#fff",
    fontSize: 28,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpExclamation);
export default __webpack_public_path__ + "static/media/help-exclamation.354e72eb1b84d97fcc2f5ff6bf93367f.svg";
export { ForwardRef as ReactComponent };